import globalSlice from "./slices/globalSlice";
import questionSlice from "./slices/QuestionSlice";
import categorySlice from "./slices/CategorySlice";
import subscriptionSlice from "./slices/subscriptionSlice";
import eventSlice from "./slices/eventSlice";
import paymentSlice from "./slices/paymentSlice";
import loginSlice from "./slices/loginSlice";
import signupSlice from "./slices/SignupSlice";
import profileSlice from "./slices/profileSlice";
import faqSlice from "./slices/FaqSlice";
import userSlice from "./slices/userSlice";
import { combineReducers } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  global: globalSlice,
  question: questionSlice,
  category: categorySlice,
  subscription: subscriptionSlice,
  events: eventSlice,
  payments: paymentSlice,
  login: loginSlice,
  signup: signupSlice,
  profile: profileSlice,
  faq: faqSlice,
  user: userSlice,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
